export const FILTER_SORT_APPLICATION_FAILED = 'FILTER_SORT_APPLICATION_FAILED';

export const NETWORK_ERROR = 'NETWORK_ERROR';
